export default "__VITE_ASSET__BmYR426I__"